/**
 * ######################
 * #      NOTE          #
 * ######################
 *
 * This is a copy from the web socket interfaces of the web shop.
 * Adjustments of the interfaces must be done there too.
 *
 */

export interface PubSubJoinGroup {
  type: 'joinGroup';
  group: string;
  ackId?: number;
}

export interface PubSubLeaveGroup {
  type: 'leaveGroup';
  group: string;
  ackId?: number;
}

export interface PubSubSendToGroup {
  type: 'sendToGroup';
  group: string;
  ackId?: number;
  noEcho?: boolean;
  dataType: 'json' | 'text' | 'binary';
  data: any;
}

export enum PubSubMessageType {
  MESSAGE = 'message',
  ACK = 'ack',
  SYSTEM = 'system',
}

export interface PubSubMessageResponse {
  type: PubSubMessageType.MESSAGE;
  from: 'group' | 'server';
  group?: string;
  ackId?: number;
  dataType: 'json' | 'text' | 'binary';
  data: any;
}

export interface PubSubAckResponse {
  type: PubSubMessageType.ACK;
  ackId?: number;
  success: boolean;
  error?: {
    name: string;
    message: string;
  };
}

export enum PubSubSystemEventEnum {
  CONNECTED = 'connected',
  DISCONNECTED = 'disconnected',
}

export interface PubSubSystemResponse {
  type: PubSubMessageType.SYSTEM;
  event: PubSubSystemEventEnum;
  userId?: string;
  connectionId?: string;
  message?: string;
}
